import classNames from 'classnames'
import Image from 'next/image'
import React, { PropsWithChildren } from 'react'
import { Column } from '../../../components/Column'
import {
  BlockquoteType,
  BlokType,
  BulletListType,
  HeadingType,
  HorizontalRuleType,
  OrderedListType,
  ParagraphType,
} from '../../../components/Column/blokTypes'
import classes from './imageColumns.module.scss'

export type BodyType = {
  body: {
    content: (HeadingType|ParagraphType|HorizontalRuleType|BulletListType|OrderedListType|BlockquoteType|BlokType)[]
  }
}

type ImageColumnsType = {
  _uid: string
  component?: 'services_detail'
  image_type: string
  image_side: string
  subtitle: string
  title: string
  image: {
    filename: string
  }
  content: BodyType[]
}

export const ImageColumnsBase: React.FC<PropsWithChildren<ImageColumnsType>> = ({ image_type, image_side, image, title, subtitle, content, _uid }) => {
  const containerClasses = [classes.container]
  const imageClasses = [classes.image_container]

  switch (image_side) {
  case 'left':
    containerClasses.push(classes.right_align)
    imageClasses.push(classes.left_image)
    break
  case 'right':
    containerClasses.push(classes.left_align)
    imageClasses.push(classes.right_image)
    break
  default:
    break
  }

  if (image_type === 'vertical_rectangle') containerClasses.push(classes.verticalRectangle)


  const renderImageTypes = ()=> {
    switch (image_type){
    case'rectangle':
      return (
        <div className={classes.horizontalImageMask}>
          <Image objectFit="cover" src={image.filename} width={1000} height={700} />
        </div>
      )
    case 'vertical_rectangle':
      return (
        <div className={classes.verticalImageMask}>
          <Image objectFit="cover" src={image.filename} width={830} height={1140} />
        </div>
      )
    case 'default':
      return (
        <div className={classes.defaultImage}>
          <Image objectFit="cover" src={image.filename} width={1000} height={730} />
        </div>
      )
    }
  }

  return (
    <section className={classNames(containerClasses)}>
      <div className={classNames(imageClasses)}>
        {
          renderImageTypes()
        }
      </div>
      <section className={classes.contentColumn}>
        <h3 className={classes.headerThree}>{subtitle}</h3>
        <h2 className={classes.headerTwo}>{title}</h2>
        <Column className={classes.column} body={{ content: content?.[0]?.body?.content }} key={_uid} href={''} variant={'default'} src={{
          filename: '',
          alt: '',
        }} component={'column'} _uid={''} size={'default'} align={'center'} full_width={true} mob_size={'default'} />
      </section>
    </section>
  )
}

const ImageColumns:React.FC<PropsWithChildren<{ slice: ImageColumnsType }>> = ({ slice })  => {
  return (
    <>
      {slice?.image.filename ? (
        <ImageColumnsBase image_type={slice.image_type} image_side={slice.image_side} image={slice?.image} _uid={slice._uid} title={slice.title} subtitle={slice.subtitle} content={slice.content} />
      ) : null}
    </>
  )
}

export default ImageColumns
